import { Box, Grid, Link, Typography, useTheme } from "@mui/material";
import { legalLinks } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";
import { getLegalLinkStyles } from "../styles";
import { useEffect, useState } from "react";

const LegalSection = () => {
  const theme = useTheme();
  const isDesktop = useResponsive('up', 'md')
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row-reverse" }}
      justifyContent="space-between"
      pt={{ xs: 0, md: 4.25 }}
    >
      <Grid container mb={{ xs: 2.5, md: 0 }} maxWidth={{ xs: 'auto', md: 350 }}>
        {legalLinks.map(({ label, link }, index) => (
          <Grid key={index} item xs={6} sm={4} md={6}>
            <Link
              key={index}
              sx={getLegalLinkStyles(theme, isDesktop)}
              href={link}
            >
              <Typography
                variant="body1"
                fontSize={16}
                component="span"
                color="inherit"
                textTransform="capitalize"
              >
                {label}
              </Typography>
            </Link>
          </Grid>
        ))}
      </Grid>

      <Typography
        variant="body2"
        component="p"
        color="white"
        fontSize={14}
        sx={{ opacity: 0.3, minWidth: "50%" }}
      >
        {currentYear} TrackmateGPS. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default LegalSection;
